import CustomerService from "../services/customer.service";
const state = {
    excludes: [],
    isLoading: false,
    error: ''
};

const getters = {
    GET_EXCLUDES(state) {
        return state.excludes;
    }
}

const actions = {
    LOAD_EXCLUDES: async function ({commit}) {
        commit('LOADING_START');
        commit('SET_DATA', []);

        try {
            const data = await CustomerService.excludes();
            commit('SET_DATA', data);
            return true;
        } catch (e) {
            commit('SET_ERROR', e);
            return false
        } finally {
            commit('LOADING_END');
        }
    }
};

const mutations = {
    LOADING_START(state) {
        state.isLoading = true;
    },

    LOADING_END(state) {
        state.isLoading = false;
    },

    SET_DATA(state, data) {
      state.excludes = data;
    },

    SET_ERROR(state, error) {
        state.error = error;
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}